<template>
	<div>
		<v-dialog v-model="dialog_opening" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
        	<v-card>
        	  	<v-card-text>
        	  		<v-form data-vv-scope="field">
        	  			<v-layout row wrap>

					        <v-flex xs12 sm12 md12>
        	  					<v-text-field
        	  						prefix="₹"
		        	  			  	label="Rate"
		        	  			  	placeholder=" "
		        	  			  	type="number"
		        	  			  	v-model.number="openingObj.rate"
		        	  			  	v-validate="'decimal:4'"
				               		data-vv-name="rate"
				               		:error-messages="errors.collect('field.rate')" 
		        	  			></v-text-field>
		        	  		</v-flex>

	        	  			<v-flex xs12 sm12 md12>
        	  					<v-text-field
        	  						:suffix="openingObj.selectedUnit == $parent.Form.secondUnitId ? $parent.Form.secondUnitName : $parent.Form.unitName"
		        	  			  	label="Quantity"
		        	  			  	placeholder=" "
		        	  			  	type="number"
									@input="$root.fn_boundDecimalLength(openingObj, null, 'qty')"
		        	  			  	v-model="openingObj.qty"
		        	  			  	v-validate="'required'"
				               		data-vv-name="quantity"
				               		:error-messages="errors.collect('field.quantity')" 
		        	  			></v-text-field>
		        	  		</v-flex>

							<v-flex xs12 sm12 md12 v-if="$parent.Form.secondUnitId">
								<div>{{ $parent.Form.primaryUnitPackQuantity }} {{ $parent.Form.unitName }} = {{ $parent.Form.secondaryUnitPackQuantity }} {{ $parent.Form.secondUnitName }}</div>
								<!-- <v-btn color="primary" flat small capitalize @click="fn_openDialogVariant">Add Secondary Unit</v-btn> -->
							</v-flex>

							  <v-flex xs12 sm12 md12 v-if="$parent.Form.secondUnitId">
								<v-radio-group @change="fn_unitChange" :hide-details="true" v-model="openingObj.selectedUnit" row>
									<v-radio :label="$parent.Form.unitName" :value="$parent.Form.unitId"></v-radio>
									<v-radio :label="$parent.Form.secondUnitName" :value="$parent.Form.secondUnitId"></v-radio>
								</v-radio-group>
							  </v-flex>
        	  			</v-layout>
        	  		</v-form>
        	  	</v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_checkValidations">done</v-btn>
		        </v-card-actions>
	        </v-card>	
      	</v-dialog>
	</div>
</template>

<script>
export default{
	data(){	
		return{
			dialog_opening: false,
			openingObj:{rate:null,qty:null,selectedUnit:null}
			// rate:null,
			// quantity:null
		}
	},
	methods:{
		openDialogWeb: function () {
			this.errors.clear('fields');
			// this.quantity = this.$parent.Form.openingQty;
			// this.rate = this.$parent.Form.openingRate;
			this.openingObj.qty = this.$parent.Form.openingQty;
			this.openingObj.rate = this.$parent.Form.openingRate;
			this.dialog_opening = true;
		},
		closeDialogWeb: function () {
			this.dialog_opening = false;
		},
		fn_unitChange: function(value){
			if(value == this.$parent.Form.secondUnitId){
				this.openingObj.rate = this.roundUpto2Decimals((this.openingObj.rate * this.$parent.Form.primaryUnitPackQuantity) /this.$parent.Form.secondaryUnitPackQuantity);
			}
			else{
				this.openingObj.rate = this.roundUpto2Decimals((this.openingObj.rate * this.$parent.Form.secondaryUnitPackQuantity) / this.$parent.Form.primaryUnitPackQuantity);
			}
		},
		fn_checkValidations: function () {
			this.$validator.validateAll('fields').then((result) => {
				if(result){
					// if(this.quantity <= 0){
					if(this.openingObj.qty <= 0){
						this.showToast("Opening should be greater than zero");
						return;
					}
					// this.$parent.fn_setOpening(this.quantity, this.rate);
					this.$parent.fn_setOpening(this.openingObj.qty, this.openingObj.rate, this.openingObj.selectedUnit);
				}
		    });
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/product/dialogs/dialog_opening.vue